import styled from 'styled-components';
import { breakpoints, colorCSS, cssColorsFromBackgroundField } from '../../styles';
//style variables
const globeSize = '20px';
const textColor = colorCSS('N0');
const backgroundColor = colorCSS('N800');
//styled components
export const Footer = styled.footer `
  ${cssColorsFromBackgroundField({ color: 'N800' })}

  section {
    color: ${textColor};

    span {
      font-size: 1rem;
    }

    svg {
      max-width: 125px;
    }

    a,
    button {
      color: ${textColor};
      text-decoration: none;
      &:hover {
        color: ${textColor};
        text-decoration: underline;
      }
    }

    ul {
      text-align: left;
      list-style-type: none;
      padding: 0;
    }
  }
`;
export const LogoAndLoginContainer = styled.div `
  margin: 1.5rem 1rem 0 1rem;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  gap: 1.75rem;

  a {
    padding: 0;
    margin: 0;
  }

  @media (min-width: ${breakpoints.lg}px) {
    flex-direction: column;
    align-items: stretch;
    margin: 1rem 1rem 0 0;
    gap: 1rem;
  }
`;
export const TabsList = styled.ul `
  margin: 0 0 0 1rem;

  h4,
  p {
    color: ${textColor};
    width: 60%;
    margin: 0;
    padding: 0;
  }

  div > p {
    color: ${textColor};
  }

  a {
    margin: 0;
    padding: 0;
  }

  li {
    border-bottom: 1px solid ${colorCSS('N400')};
    padding: 0 0 1rem 0;
    margin: 0 0 1rem 0;
  }

  li:first-child {
    border-top: 1px solid ${colorCSS('N400')};
    margin-top: 1rem;
    padding: 1rem 0 1rem 0;
  }

  li:last-child {
    margin: 0;
  }

  @media (min-width: ${breakpoints.lg}px) {
    display: flex;
    flex-wrap: wrap;
    margin: 0;

    h4,
    p {
      width: 100%;
    }

    a {
      padding: 1rem;
      gap: 0.25rem;
      height: 100%;
      &:hover {
        text-decoration: none !important;
        background-color: ${colorCSS('N600')};
      }
    }

    li {
      border: none;
      padding: 0;
      margin: 0;
      width: 25%;
    }

    li:first-child {
      border: none;
      padding: 0;
      margin: 0;
    }
  }
`;
export const Divider = styled.div `
  @media (min-width: ${breakpoints.lg}px) {
    border-top: 1px solid ${colorCSS('N400')};
    width: 98%;
    margin: 0 auto;
  }
`;
export const LanguageForm = styled.form `
  display: inline-block;
  min-height: ${globeSize};
  margin-left: 1rem;
  padding-left: 2rem;
  position: relative;
  max-width: 100%;

  select {
    appearance: none;
    border: 0;
    color: ${textColor};
    display: block;
    font-family: inherit;
    font-size: 1rem;
    background-color: ${backgroundColor};
    background-image: url("data:image/svg+xml,%3Csvg fill='%23fff' height='8' viewBox='0 0 13 8' width='13' xmlns='http://www.w3.org/2000/svg' %3E%3Cpath d='m11.7305.59279c.3626.362629.3885.93447.0777 1.32699l-.0777.08722-4.99999 4.99999c-.36263.36263-.93446.38853-1.32697.0777l-.08725-.0777-4.999959-4.99997c-.3905249-.39052-.3905242-1.023685 0-1.414209.362629-.36263.934469-.388553 1.326989-.077728l.08722.077728 4.29292 4.292139 4.29284-4.29216c.3626-.36263.9345-.388532 1.327-.077707z' /%3E%3C/svg%3E");
    background-position: center right;
    background-repeat: no-repeat;
    padding-right: 0.75rem;
    cursor: pointer;
    max-width: 80%;

    @media (min-width: ${breakpoints.lg}px) {
      max-width: 90%;
    }
  }
  &::before {
    background-image: url("data:image/svg+xml,%0A%3Csvg width='25px' height='24px' viewBox='0 0 25 24' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cpath d='M2.33514634,13.0909091 C2.80456741,17.1674997 5.87382928,20.4918664 9.91593939,21.5020963 C8.18760918,19.0069673 7.13798566,16.119686 6.87807529,13.0909091 L2.33514634,13.0909091 Z M2.33514634,10.9090909 L6.8751035,10.9090909 C7.12988231,7.89470494 8.18079774,5.00118821 9.91557751,2.49799419 C5.87364609,3.50833206 2.8045534,6.83262197 2.33514634,10.9090909 Z M22.6648537,10.9090909 C22.1954326,6.83250032 19.1261707,3.50813364 15.0840606,2.49790374 C16.8123908,4.99303266 17.8620143,7.88031403 18.1219247,10.9090909 L22.6648537,10.9090909 Z M22.6648537,13.0909091 L18.1248965,13.0909091 C17.8701177,16.1052951 16.8192023,18.9988118 15.0844225,21.5020058 C19.1263539,20.4916679 22.1954466,17.167378 22.6648537,13.0909091 Z M9.15315078,10.9090909 L15.843646,10.9090909 C15.5581939,7.94925479 14.3973512,5.12935736 12.4999751,2.78265622 C10.595448,5.13778492 9.43302782,7.96652031 9.15315078,10.9090909 Z M15.8468492,13.0909091 L9.15635402,13.0909091 C9.44180608,16.0507452 10.6026488,18.8706426 12.5000249,21.2173438 C14.404552,18.8622151 15.5669722,16.0334797 15.8468492,13.0909091 Z M12.5,24 C5.59644063,24 0,18.627417 0,12 C0,5.372583 5.59644063,0 12.5,0 C19.4035594,0 25,5.372583 25,12 C25,18.627417 19.4035594,24 12.5,24 Z' fill='white'%3E%3C/path%3E%3C/svg%3E%0A");
    background-position: center left;
    background-repeat: no-repeat;
    background-size: ${globeSize};
    bottom: 0;
    content: '';
    left: 0;
    min-height: ${globeSize};
    position: absolute;
    top: 0;
    min-width: ${globeSize};
  }

  @media (min-width: ${breakpoints.lg}px) {
    margin: 0;
  }
`;
export const SubNav = styled.nav `
  ul {
    li {
      margin: 0 0 0 1rem;
      a,
      button,
      span {
        font-size: 0.75rem;
      }
    }
  }

  @media (min-width: ${breakpoints.lg}px) {
    ul {
      display: flex;
      flex-wrap: nowrap;
      li {
        margin: 0 1.5rem 0 0;
      }
      li:first-child {
        margin: 0 1.5rem 0 1rem;
      }
    }
  }
`;
export const SocialNavLinks = styled.nav `
  display: flex;
  margin: 3rem 1rem 0 1rem;
  padding: 0 0 3rem 0;
  gap: 2rem;

  @media (min-width: ${breakpoints.lg}px) {
    justify-content: space-between;
    gap: 0;
    margin: 0;
    padding: 0 0.25rem 1rem 0;
  }

  a {
    align-items: center;
    background-color: ${backgroundColor};
    border-radius: 50%;
    border: 2px solid ${textColor};
    display: flex;
    height: 24px;
    margin: 0 !important;
    width: 24px;
    svg {
      height: 60%;
      margin: auto;
      transition: all 0.15s;
      width: 60%;
      path {
        fill: ${textColor};
      }
    }
    &:hover {
      svg {
        height: 50%;
        width: 50%;
        path {
          fill: ${textColor};
        }
      }
    }
  }
`;
//# sourceMappingURL=UiFooterNav.styles.js.map